import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { PermissionAction, PermissionEffect } from './role.interface';

export enum PermissionConditionRule {
  EQUALS = 'equals',
  CONTAINS = 'contains',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  GT = 'gt',
  LT = 'lt',
  GTE = 'gte',
  LTE = 'lte'
}

export interface CollectionMetadata {
  name: string;
  fields: CollectionField[];
}

export interface CollectionField {
  name: string;
  type: string;
  isRequired: boolean;
  isList: boolean;
  kind: string;
  relationName?: string;
  supportedRules: PermissionConditionRule[];
}

export interface PermissionCondition {
  propertyName: string;
  propertyValue: string;
  rule: PermissionConditionRule;
}

export interface CreateRoleDto {
  name: string;
  permissions: {
    effect: PermissionEffect;
    action: PermissionAction;
    collection: string;
    fields: string[];
    conditions: PermissionCondition[];
  }[];
}

export interface PermissionConditionForm {
  propertyName: FormControl<string>;
  propertyValue: FormControl<string>;
  rule: FormControl<PermissionConditionRule>;
  nestedConditions?: FormArray<FormGroup<PermissionConditionForm>>;
}

export interface PermissionConditionState {
  showPropertySelector: boolean;
  showOperatorSelector: boolean;
  fields: CollectionField[];
  propertyOptions: { name: string; type: string }[];
  selectedField?: CollectionField;
  ruleOptions: { label: string; value: PermissionConditionRule }[];
}
